
import { Vue, Component, Prop } from "vue-property-decorator";

interface CareGoalsData {
  short_term_goals: string;
  long_term_goals: string;
  specific_care_needs: string;
  desired_outcomes: string;
  self_directed_care_preferences: string;
}

@Component
export default class CareGoals extends Vue {
  @Prop({ required: true }) readonly data!: CareGoalsData;
}
